(() => {
  const SHOW_AFTER_MS = 10000;
  const STORAGE_KEY = 'popupBannerShown';

  const modal = document.querySelector('[data-popup-banner]');
  if (!modal) return;

  if (sessionStorage.getItem(STORAGE_KEY)) return;

  const close = () => {
    modal.hidden = true;
    document.removeEventListener('keydown', onKeydown);
  };

  const onKeydown = (event) => {
    if (event.key === 'Escape') close();
  };

  // The modal itself is the click-to-dismiss background; the dialog stops
  // that click from bubbling up so clicking the image/content doesn't close
  // it, and the close button closes directly regardless.
  modal.addEventListener('click', close);
  modal.querySelectorAll('[data-popup-banner-stop]').forEach((el) => {
    el.addEventListener('click', (event) => event.stopPropagation());
  });
  modal.querySelectorAll('[data-popup-banner-close]').forEach((el) => {
    el.addEventListener('click', close);
  });

  setTimeout(() => {
    modal.hidden = false;
    sessionStorage.setItem(STORAGE_KEY, 'true');
    document.addEventListener('keydown', onKeydown);
  }, SHOW_AFTER_MS);
})();
